import React from 'react'
import useStore from 'state/knovStore'

export default function TwitterAuthError({ modalParams, closeModal }) {
    const openEditProfileModal = useStore(state => state.actions.modalActions.openEditProfileModal)

    const handleReconnect = () => {
        closeModal()
        // Open the Settings modal using the proper Zustand action
        openEditProfileModal()
    }

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <div style={{ marginBottom: '20px' }}>
                <i
                    className="fa fa-exclamation-triangle"
                    style={{ fontSize: '48px', color: '#f0ad4e' }}
                />
            </div>
            <div style={{ marginBottom: '20px', fontSize: '16px' }}>
                {modalParams.message ||
                    'Twitter authentication expired. Please reconnect your Twitter account.'}
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                <button
                    onClick={handleReconnect}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#1DA1F2',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Go to Settings
                </button>
                <button
                    onClick={closeModal}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#e0e0e0',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Close
                </button>
            </div>
        </div>
    )
}
